<template>
  <div style="position: relative;">
      <span class="picNum">共{{pictures.length}}张</span>
      <span v-if="brandName" class="brand">{{brandName}}</span>
      <img :style="{'height': height + 'px','width': width + 'px'}" :class="firstSheet ? 'imgPic' : ''" :src="firstSheet ? firstSheet : noImage" alt="">
      <showPicture ref="showPicture"></showPicture>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

import MobileChat from "@/components/ChatGPT3.0/MobileChat.vue";
import showPicture from "@/components/Picture.vue";
export default {
  name:  '',
  components: {
      MobileChat,showPicture
  },
  props: {
     'state': {
         type: Number,
         default: () => {
             return 0
         }
     },
    'brandName': {
        type: String,
        default: () => {
            return ''
        }
    },
    'pictures': {
      type: Array,
      default: () => {
        return []
      }
    },
    'name': {
      type: String,
      default: () => {
          return ''
      }
    },
    'height': {
      type: Number,
      default: () => {
        return 148
      }
    },
    'width': {
      type: Number,
      default: () => {
        return 200
      }
    }
  },
  // 定义属性
  data() {
    return {
      noImage: require('@/assets/png/noImage.png'),
      firstSheet: '',
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
     show() {
         this.$refs.showPicture.init(this.pictures,this.state)
     },
    // 根据传入的值获取酒店详情页展示图
    getAPictureWithTheSpecifiedName() {
        if(!this.pictures.length) return
        if (this.name) {
            let av = this.pictures.filter(x => x.name&&x.name === this.name)
            if (av.length > 0) {
                this.firstSheet = av[0].path
            } else {
                this.firstSheet = this.pictures[0].path
            }
        } else {
            this.firstSheet = this.pictures[0].path
        }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getAPictureWithTheSpecifiedName()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {}, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped lang="scss">
.imgPic {
  height: var(--height);
  width: var(--width);
  &:hover {
    cursor: pointer;
  }
}
.picNum {
  position: absolute;
  right: 5px;
  bottom: 5px;
  color: white;
}
.brand {
  position: absolute;
  left: 0;
  top: 0;
  padding-left: 3px;
  padding-right: 3px;
  padding-top: 1px;
  padding-bottom: 1px;
  background: black;
  color: gold;
}
</style>